var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.orgLogoShow)?_c('div',{staticClass:"org-logo-wrap"},[_c('v-img',{attrs:{"lazy-src":_vm.orgLogo,"src":_vm.orgLogo,"position":_vm.position,"max-height":"110","contain":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }